import React, {useState} from 'react';
import AppContext from "./AppContext";
import baseUrl from "../config/config";
import axios from "axios";

const AppState = (props) => {
    const [user, setUser] = useState({});
    const [store, setStore] = useState( {
        giftLists: {},
            parentMode: true,
            addForm: false,
            currentChild: false,
            currentChildName: false,
            currentGift: false,
            addEdit: false,
            addDelete: false,
            giftEdit: false,
            giftDelete: false,
            children: []
    } )
    const createUser = (user) => {
        return axios.post(`${baseUrl}/api/users`, user, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
            .then((response) => response.data)
    };
    const login = async( user ) => {
        return axios.post( `${baseUrl}/auth/login`, user, {
            withCredentials: true,
        } ).then( ( response ) => response.data
        )
    }
    const logout = ( user ) => {
        return axios.get( `${baseUrl}/auth/logout`, {
            withCredentials: true,
        }, )
            .then( ( response ) => response.data )
    };
    const resetPasswordViaEmail = async( userEmail ) => {
        return axios.post( `${baseUrl}/api/users/send-reset-password-email`, userEmail )
            .then( ( response ) => response.data
        )
    }
    const resetPassword = (resetToken, data) => {
        return axios.post( `${baseUrl}/api/users/reset-password/${resetToken}`, data )
                .then( ( response ) => response.data
                )
    }
    const getChildren = (userId) => {
        return axios.get(`${baseUrl}/dashboard/${userId}`)
            .then((response) => response.data);
    }
    const getChildGiftList = async (childUid) => {
       return await axios.get(`${baseUrl}/lettertosanta/${childUid}`)
           .then((response) => response.data);
    };
    const addChildDB = async (userId, childData) => {
      return await axios.post(`${baseUrl}/dashboard/${userId}/children`, childData)
          .then((response) => response.data);
    };
    const addChildGiftList = async (childUid, giftList) => {
        return  await axios.post(`${baseUrl}/lettertosanta/${childUid}`, giftList)
            .then((response) => response.data);
    };
    const updateChildDB = async (userId, childId, data) => {
        return await axios.patch(`${baseUrl}/dashboard/${userId}/children/${childId}`, data)
            .then((response) => response.data)
    }
    const deleteChildDB = async (userId, childId) => {
        return await axios.delete(`${baseUrl}/dashboard/${userId}/children/${childId}`)
            .then((response) => response.data)
    }
    const getAllGifts = async (userId) => {
        return await axios.get(`${baseUrl}/giftlist/${userId}`)
            .then((response) => response.data);
    }
    const createReciverGift = async (userId, userData) => {
        return await axios.post(`${baseUrl}/giftlist/${userId}`, userData)
            .then((response) => response.data);
    }
    const deleteGiftList = async (userId, uid) => {
        return await axios.delete(`${baseUrl}/giftlist/${userId}/${uid}`)
            .then((response) => response.data);

    };

    const changeReciverName = async (userId, data) => {
        return await axios.patch(`${baseUrl}/giftlist/${userId}`, data)
            .then((response) => response.data);
    }

    const addGiftInArray = async (userId, uid, data) => {
        return await axios.post(`${baseUrl}/giftlist/${userId}/gifts/${uid}`, data)
            .then((response) => response.data);
    }

    const editSelectedGift = async (userId, uid, data) => {
        return await axios.patch(`${baseUrl}/giftlist/${userId}/gifts/${uid}`, data)
            .then((response) => response.data);
    }

    const deleteSelectedGift = async (userId,uid, data) => {
       return await  axios.delete(`${baseUrl}/giftlist/${userId}/gifts/${uid}`, {
            data: data
        }).then(response => response.data)

    }
    return (
        <>
            <AppContext.Provider value={{login, setUser, user, createUser, logout,
                resetPasswordViaEmail, resetPassword, store, setStore, getChildren,
                getChildGiftList, addChildDB, addChildGiftList, updateChildDB,
                deleteChildDB, createReciverGift, addGiftInArray, deleteSelectedGift, editSelectedGift
                ,deleteGiftList, changeReciverName, getAllGifts}}>
                {props.children}
            </AppContext.Provider>
        </>
    );
}
export default AppState
